export default __webpack_public_path__ + "static/sub-bg-image-02a54ce8f2e3fb680e0eb373a5a986db.webp";